import {RoiHandlerBase} from './RoiHandlerBase';
import {ClearRectangle} from './shapes/ClearRectangle';
import us from '../../../defines';

/**
 * Defines a handler that allows a user to draw a box on the viewport.
 */
export class RoiHandlerResizable extends RoiHandlerBase {
  init (surface) {
    const self = this;
    const state = {};

    surface.setMouseEventHandlers({
      // On mouse down the user declares his intent to start drawing. This is our origin, so we capture it.
      mousedown (mouse, dragOffset, e) {
        // Create a 0 dimensional rectangle at the cursor position.
        state.shape = new ClearRectangle(mouse.x, mouse.y, 0, 0);
        // We want to drag from where we first clicked, so we save the offset.
        state.dragOffset = {
          x: mouse.x - state.shape.x,
          y: mouse.y - state.shape.y
        };

        surface.addShape(state.shape);
      },

      // Once the user has started drawing, we resize our rectangle to match the user's cursor position.
      mousemove (mouse, dragOffset, e) {
        // If the user hasn't started drawing, do nothing.
        if (state.shape) {
          // Set the height and width.
          state.shape.w = mouse.x - state.dragOffset.x - state.shape.x;
          state.shape.h = mouse.y - state.dragOffset.y - state.shape.y;

          // Constrain the height and width to the max dimensions.
          state.shape.w = constrain(state.shape.w, us.IMAGESERVER_MAXJDIM);
          state.shape.h = constrain(state.shape.h, us.IMAGESERVER_MAXJDIM);

          // Invalidate the surface, triggering a repaint on the next draw() cycle.
          surface.valid = false;
        }
      },

      // Once the user lets go of the mouse we're done.
      mouseup (mouse, dragOffset, e) {
        surface.clearMouseHandlers();

        // Silly but you never know...
        if (!state.shape) {
          return;
        }

        self.signalUserActionComplete(state.shape);

        RoiHandlerBase.normalizeAndOffset(state.shape, self.settings.viewportInfo);

        self.finish(state.shape);
      }
    });
  }
}

// Constrains abs(val) to max, preserving sign.
function constrain (val, max) {
  const sign = (val < 0) ? -1 : +1;
  if (Math.abs(val) > max) {
    val = max * sign;
  }
  return val;
}
